'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const SecondUseIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.31006 14.25V8.14C5.31006 5.72 7.28006 3.75 9.70006 3.75C10.9201 3.75 12.0101 4.25 12.8101 5.03C13.5901 5.83 14.0901 6.92 14.0901 8.14V9.15H15.1001C17.5201 9.15 19.4901 11.12 19.4901 13.54C19.4901 14.76 18.9901 15.85 18.2101 16.65C17.4101 17.45 16.3201 17.93 15.1001 17.93H5.90006M8.39006 15.17L5.64006 17.92L8.39006 20.67",
        stroke: "currentColor",
        strokeMiterlimit: 10
      }
    )
  }
);
const VpSecondUseIcon = forwardRef(SecondUseIcon);

export { VpSecondUseIcon as default };
